import Vue from 'vue';

export default Vue.extend({
	name: 'CWrap',
	functional: true,
	props: {
		when: {
			type: Boolean,
			required: true
		},
		tag: {
			type: String,
			default: 'div'
		}
	},
	render: function (createElement, context) {
		return context.props.when ? createElement(context.props.tag, context.data, context.children) : context.children;
	}
});